module.exports = __webpack_public_path__ + "img/4.01ff3971.png";